import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/hooks/useLanguage";

export function ProductCTA() {
  const { t } = useTranslation();
  const { getLocalizedPath } = useLanguage();

  return (
    <section className="py-12 lg:py-28 bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-xl mx-auto"
        >
          <h2 className="text-3xl md:text-4xl font-medium font-heading tracking-tight">
            {t("productPages.ctaTitle")}
          </h2>
          <p className="mt-4 text-lg text-primary-foreground/70 font-body">
            {t("productPages.ctaSubtitle")}
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              size="lg"
              asChild
              className="bg-coral text-coral-foreground hover:bg-coral/90 font-semibold shadow-lg shadow-coral/25 text-base px-8"
            >
              <Link to={getLocalizedPath("/bestall")}>
                {t("productPages.ctaOrder")}
                <ArrowRight className="ml-1 h-4 w-4" />
              </Link>
            </Button>
            <Button
              variant="outline"
              size="lg"
              asChild
              className="bg-transparent border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground/10 font-medium text-base"
            >
              <Link to={getLocalizedPath("/kontakt?type=demo")}>{t("productPages.ctaButton")}</Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
